/**
 * @module app.bdc.files.filesCtrl
 *
 */
define(['angular', 'moment'], function(angular, moment) {


    function FilesCtrl($scope, $window, filesService) {
        // $scope.selectActiveMenu(5);
        let self = {};

        self.filesService = filesService;

        self.download = function download(url) {
            $window.open(filesService.ROOT_PATH + url, '_blank');
        };

        return self;
    }

    FilesCtrl.$inject = ['$scope', '$window', 'filesService'];

    angular.module('app.bdc.files.filesCtrl', []).controller('FilesCtrl', FilesCtrl);
});
